import React from "react"
import { useTranslation, Trans } from "react-i18next"
import Button from "../../shared/components/buttons/Button"
import { StyleVariants } from "../../shared/state/sharedTypes"
import { RoutePaths } from "../../app/routes/Routes"
import { useSelector } from "react-redux"
import { getCurrentUser } from "../../shared/selectors/user"
import { IUser } from "../../features/user/state/userTypes"

const SetupSmsCompletePage: React.FC = (): JSX.Element => {
  const { t } = useTranslation(["account", "shared"])
  const currentUser: IUser = useSelector(getCurrentUser)

  const renderLinkToSetupTotp =
    <div className="mb-5">
      <Trans i18nKey='mfaSetupTotpAsWell' t={t} >
        Click <a className="text-ch-blue-500 hover:text-ch-blue-600" href={RoutePaths.SETUP_MFA_INTRO}>here</a> if you wish to set up TOTP based 2FA as well.
      </Trans>
    </div>

  return (
    <div className="flex flex-col items-center">
      <div className="text-ch-blue-500 text-xl mb-3">
        {t("mfaSetupCompleteHeader")}
      </div>
      <div className="mb-5">
        {t("mfaSetupSmsCompleteMessage")}
      </div>
      {currentUser?.mfaMethods.includes("totpq") ? null : renderLinkToSetupTotp}
      <Button variant={StyleVariants.BLUE} href={RoutePaths.ROOT}>{t("mfaContinueToApp")}</Button>
    </div >
  )
}

export default SetupSmsCompletePage
